import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import {
    receive_sectional_content,
    sectional_content_fetch_error,
} from "../../reducers/SectionalContent/reducer";
import { fetchSingleLineup } from "../../fetch/graphql/requests/lineups/index";
import {
    getCategorySlug,
    getLineupSlug,
    getSubjectsSet,
    shouldFetchSectionalContent,
} from "../../utils/path/library";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import {
    maybeOverrideCategorySlug,
    formatHeadlines,
} from "../../utils/dataTransform/utils";
import { DEFAULT_PAGE_SIZE } from "../../constants/content";
import log from "../../utils/logger/library";
import { fetchAllKeyValues } from "../../fetch/graphql/requests/keyValues";

export function fetch_sectional_content_graphql(
    section,
    itemCount = DEFAULT_PAGE_SIZE
) {
    return async (dispatch, getState) => {
        if (!section) {
            return;
        }
        const state = getState();
        const lineupSlug = getLineupSlug(section);
        const subjectsSet = getSubjectsSet(section);
        const sectionExists = !!state.sectionalContent[section];
        const categorySlug = maybeOverrideCategorySlug(
            section,
            getCategorySlug(section)
        );

        if (
            !shouldFetchSectionalContent({
                category: categorySlug,
                lineup: lineupSlug,
                sectionExists,
            })
        ) {
            return;
        }

        dispatch(start_loading());
        try {
            let {
                allContentItems: { nodes },
            } = await fetchSingleLineup({
                lineupSlug,
                categorySlug,
                subjectsSet,
                tags: "",
                page: 1,
                pageSize: Number(itemCount),
            });
            formatHeadlines(section, nodes);
            nodes = transformAllContentItems(nodes);

            dispatch(
                receive_sectional_content({
                    sectionList: nodes,
                    section,
                    timestamp: Date.now(),
                })
            );
        } catch (error) {
            dispatch(
                sectional_content_fetch_error({
                    section,
                })
            );

            log.error(
                `(fetch_sectional_content_graphql) request failed for section ${section}`,
                error
            );
        } finally {
            dispatch(set_loading_complete());
        }
    };
}

export function fetch_sectional_content_all_sports(section) {
    return async (dispatch, getState) => {
        if (!section) {
            return;
        }
        const state = getState();
        const currentContent = state.sectionalContent[section];
        if (currentContent && currentContent.sectionList) {
            return;
        }

        const season = /\/summer\//.test(section) ? "summer" : "winter";

        dispatch(start_loading());
        try {
            const keyValuePair = await fetchAllKeyValues(
                `ocelot.olympics.${season}.allsports`
            );
            const nodes = keyValuePair.allKeyValues.nodes[0].value;
            dispatch(
                receive_sectional_content({
                    sectionList: nodes,
                    section,
                    timestamp: Date.now(),
                })
            );
        } catch (error) {
            log.error("(fetch_sectional_content_all_sports)", error);
        } finally {
            dispatch(set_loading_complete());
        }
    };
}
